import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Something_went_wrong, Request_Thank_You } from "@root/app.constant";
import { Urls } from "../../../utils/urls";
import { ApiService } from "../../../shared/services/api.service";
import { CommonDataService } from "../../../shared/services/common-data.service";

@Component({
  selector: "app-regulatory-message-display",
  templateUrl: "./regulatory-message-display.component.html",
  styleUrls: ["./regulatory-message-display.component.scss"],
})
export class RegulatoryMessageDisplayComponent implements OnInit {
  flag = true;

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.delayLoop();
  }

  delayLoop() {
    setTimeout(() => {
      this.displayMessage();
    }, 5000);
  };


  displayMessage() {
    this.flag = !this.flag;
    console.log('Flag -->', this.flag);
    this.delayLoop();
  }

  redirectTo(flag) {
    if (flag) {
      window.open('https://eportal.incometax.gov.in/iec/foservices/#/pre-login/bl-link-aadhaar', "_blank");
    }
    else {
      window.open('https://mfs.kfintech.com/investor/General/NCTNomineeUpdation', "_blank");
    }
  }

  closeModal = () => {
    this.activeModal.close();
  };
}
